import { render, staticRenderFns } from "./EditGroupDialog.vue?vue&type=template&id=0cce495a&scoped=true"
import script from "./EditGroupDialog.vue?vue&type=script&lang=js"
export * from "./EditGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./EditGroupDialog.vue?vue&type=style&index=0&id=0cce495a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cce495a",
  null
  
)

export default component.exports